<template>
    <b-card body-class="p-3 review-types-view">
        <div class="form-sample checkofftypes">
            <div class="d-flex title-bar-block mb-2">
                <div class="icon-block me-4">
                    <button v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                        <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                    </button>
                </div>
                <div class="text">
                    <span class="me-2">{{ title }}</span>
                </div>
            </div>
            <b-tabs card align="center" class="mt-2">
                <b-tab :title="$translate('summary')" active class="p-0 mt-3">
                    <b-card-body class="p-0">
                        <b-form @submit.stop.prevent="onSubmit">
                            <b-col>
                                <label class="mb-3" for="input-name"><strong>{{ $translate('name') }}<span
                                            class="red">*</span></strong>
                                </label>
                                <b-form-input type="text" id="input-name" v-model="model.name" required
                                    v-custom-validation="$textRequired()" :placeholder="$translate('enter_name')"
                                    trim></b-form-input>
                            </b-col>
                            <b-col class="mt-3">
                                <label class="mb-3" for="input-description"><strong>{{ $translate('description') }}</strong>
                                </label>
                                <b-form-input type="text" id="input-description" v-model="model.description"
                                    :placeholder="$translate('enter_description')" trim></b-form-input>
                            </b-col>

                            <b-col class="mt-3">
                                <label class="mb-3" for="input-reasons"><strong>{{ $translate('reasons') }}</strong>
                                </label>
                                <b-form-input type="text" id="input-reasons" v-model="model.reasons"
                                    :placeholder="$translate('enter_reasons')" trim></b-form-input>
                            </b-col>
                            <b-col class="my-4 d-flex gap-3">
                                <b-col cols="auto" class="d-flex">
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input type="checkbox" id="input-enforced" v-model="model.enforced"
                                                name="input-enforced" :value="1" :unchecked-value="0" />
                                            <i class="input-helper"></i>
                                        </label>
                                    </div>
                                    <label for="input-enforced" class="mb-2 ms-2"><strong>{{ $translate('mandatory')
                                    }}</strong>
                                    </label>
                                </b-col>
                                <b-col cols="auto" class="d-flex">
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input type="checkbox" id="input-do_release" name="input-do_release"
                                                v-model="model.do_release" :value="1" :unchecked-value="0" />
                                            <i class="input-helper"></i>
                                        </label>
                                    </div>
                                    <label for="input-do_release" class="mb-2 ms-2"><strong>{{ $translate('do_release')
                                    }}</strong>
                                    </label>
                                </b-col>
                                <b-col cols="auto" class="d-flex">
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input type="checkbox" id="input-attachment_require"
                                                v-model="model.attachment_require" name="input-attachment_require"
                                                :value="1" :unchecked-value="0" />
                                            <i class="input-helper"></i>
                                        </label>
                                    </div>
                                    <label for="input-attachment_require" class="mb-2 ms-2"><strong>{{
                                        $translate('attachment_require')
                                    }}</strong>
                                    </label>
                                </b-col>
                            </b-col>

                            <b-col cols="12" class="mt-3 mb-2">
                                <div class="d-flex gap-2 justify-content-center">
                                    <b-button class="btn btn-info btn-fw" type="submit"
                                        v-if="hasPermissionCreate && !model.id" variant="primary"
                                        :disabled="loading ? true : false">{{ createLabel }}</b-button>
                                    <b-button class="btn btn-info btn-fw" type="submit"
                                        v-if="hasPermissionUpdate && model.id" variant="primary"
                                        :disabled="loading ? true : false">{{ updateLabel }}</b-button>
                                    <b-button v-if="model.id && hasPermissionDelete" size="fw" @click="deleteCheckoffType()"
                                        variant="delete-button">
                                        {{ $deleteLabel() }}
                                    </b-button>
                                    <b-button variant="info" class="btn-fw" :disabled="loading ? true : false"
                                        @click="cancel()">{{ $cancelLabel() }}</b-button>
                                </div>
                            </b-col>
                        </b-form>
                    </b-card-body>
                </b-tab>
                <b-tab :title="$translate('roles')" class="p-0" :disabled="!model.id">
                    <CheckoffTypeRoles v-if="!!item.id" />
                </b-tab>
            </b-tabs>
        </div>
    </b-card>
</template>
<script>
import CheckoffTypeRoles from './CheckoffTypeRoles.vue'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'reviewTypes-view-item',
    mixins: [permissionsMixins],
    components: { CheckoffTypeRoles },
    data() {
        return {
            loading: false,
            model: {
                id: 0,
                name: null,
                description: null,
                reasons: null,
                attachment_require: null,
                enforced: null,
                do_release: null,
            },
            updating: false,
            submitting: false,
            hasErrors: false,
        }
    },
    props: ['item'],
    computed: {
        title() {
            return this.model.id ? this.$translate('review_types') : this.$translate('create_review_type')
        },

        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
    },
    watch: {},
    mounted() {
        if (this.item.id) this.model = this.item
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        onSubmit() {
            this.loading = true
            const model = { ...this.model }
            console.log('model', model)
            const path = model.id
                ? 'checkoffTypes/update'
                : 'checkoffTypes/create'
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    model.enforced = model.enforced ? 1 : 0
                    model.do_release = model.do_release ? 1 : 0
                    model.attachment_require = model.attachment_require ? 1 : 0
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            const action = this.model.id
                                ? this.$translate('updated')
                                : this.$translate('created')
                            const message = this.model.id
                                ? this.$translate('update_alert')
                                : this.$translate('create_alert')
                            this.$emit('success', action, model.name, message)
                        })
                        .catch(error => {
                            this.$emit('danger', this.$translate('error'), error.message)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },

        deleteCheckoffType() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            // const path = 'checkoffTypes/delete'
            const path = 'checkoffTypes/delete'

            // Generate and display confirmation prompt
            const title = this.$translate('delete_review_type')
            const message = `${this.$translate('delete_note')} ${model.name}?`
            const errorMsg = 'Unable to delete Review Type!'

            this.$emit(
                'delete-item',
                title,
                message,
                model.id,
                () => {
                    this.$emit('success', this.$translate('deleted'), model.name)
                },
                path,
                errorMsg
            )
        },
    },
}
</script>
<style></style>
